import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getTcsmEpiProps, setAnnualEnrollmentSettings, setNewHireSettings, setParticipantEnrollmentSettings } from '../../../../../global/ducks/epi-api';
import { TcsmEpiApiState, TcsmStates } from '../../../../../root/tcsm-model';

export function useParticipantSettings(participantEnrollmentSettingId: string, annualEnrollmentSettingId: string, newHireSettingsId: string) {
	const dispatch = useDispatch();
	const epiApiState = useSelector<TcsmStates, TcsmEpiApiState>(state => state.epiProps);
	const language = useSelector<TcsmStates, string>(state => state.globalization.currentlanguage);
	const guid = useSelector<TcsmStates, string>(state => state.authenticatedState?.clientGuid);

	useEffect(() => {
		if (!epiApiState?.newHireSettingsState?.contentLoaded) {
			dispatch(getTcsmEpiProps(dispatch, participantEnrollmentSettingId, { guid }, language, false, setParticipantEnrollmentSettings));
		}
		if (!epiApiState?.annualEnrollmentSettingsState?.contentLoaded) {
			dispatch(getTcsmEpiProps(dispatch, annualEnrollmentSettingId, { guid }, language, false, setAnnualEnrollmentSettings));
		}

		if (!epiApiState?.newHireSettingsState?.contentLoaded) {
			dispatch(getTcsmEpiProps(dispatch, newHireSettingsId, { guid }, language, false, setNewHireSettings));
		}
	}, []);

	return epiApiState?.participantEnrollmentSettingsState?.contentLoaded && epiApiState?.annualEnrollmentSettingsState?.contentLoaded && epiApiState?.newHireSettingsState?.contentLoaded;
}